/*
 * Vencord, a modification for Discord's desktop app
 * Copyright (c) 2022 Vendicated and contributors
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

(window.VencordStyles ??= new Map()).set("src/plugins/spotifyControls/hoverOnly.css", {
    name: "src/plugins/spotifyControls/hoverOnly.css",
    source: ".vc-spotify-button-row {\n    height: 0;\n    opacity: 0;\n    pointer-events: none;\n    transition: 0.2s;\n    transition-property: height;\n}\n\n#vc-spotify-player:hover .vc-spotify-button-row {\n    opacity: 1;\n    height: 32px;\n    pointer-events: auto;\n\n    /* only transition opacity on show to prevent clipping */\n    transition-property: height, opacity;\n}\n",
    classNames: {},
    dom: null,
});

export default "src/plugins/spotifyControls/hoverOnly.css";
